// src/components/SmartFlow/nodes/index.js

/**
 * Node Registry Initialization
 *
 * This file registers all available node components with the registry.
 * Import this file to ensure all nodes are registered before use.
 */

import { nodeRegistry } from './registry/nodeRegistry';

// Import all node components
import HttpRequestNode from './node/HTTP_Request/HttpRequestNode';
import HttpRequestConfig from './node/HTTP_Request/HttpRequestConfig';
import TriggerNode from './TriggerNode';
import ActionNode from './ActionNode';
import ConditionNode from './node/Condition/ConditionNode';
import DelayNode from './DelayNode';
import EndNode from './EndNode';
import SendMessageEvolutionNode  from './node/SendMessageEvolution/SendMessageEvolutionNode'
import SendMessageEvolutionConfig  from './node/SendMessageEvolution/SendMessageEvolutionConfig'

/**
 * Initialize node components
 * This should be called once when the app starts
 */
export const initializeNodes = () => {
  nodeRegistry.registerComponent('HTTP_REQUEST', HttpRequestNode, HttpRequestConfig);
  nodeRegistry.registerComponent('TRIGGER', TriggerNode);
  nodeRegistry.registerComponent('ACTION_CRM', ActionNode);
  nodeRegistry.registerComponent('ACTION_AUTOMATION', ActionNode);
  nodeRegistry.registerComponent('ACTION_API', ActionNode);
  nodeRegistry.registerComponent('CONDITION', ConditionNode);
  nodeRegistry.registerComponent('DELAY', DelayNode);
  nodeRegistry.registerComponent('END', EndNode);
  nodeRegistry.registerComponent('EVOLUTION_SEND', SendMessageEvolutionNode, SendMessageEvolutionConfig )

  // const registeredCount = nodeRegistry.components.size;
};

export { nodeRegistry };
export { default as BaseNode } from './base/BaseNode';
